module.exports = __webpack_public_path__ + "img/LVA.934d8507.svg";